import { resolvePasskeyCallbackStatus } from '@modules/passkey/helpers/passkey-callback-status.helper';
import type {
  PasskeyCallbackQuery,
  PasskeyCallbackReason,
} from '@modules/passkey/interfaces/passkey-callback.interface';
import type { PasskeyAction } from '@shared/enums';

const appendQueryParams = (url: string, params: Record<string, string | undefined>): string => {
  const targetUrl = new URL(url, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      targetUrl.searchParams.set(key, value);
    }
  });

  return targetUrl.toString();
};

export const buildPasskeyCallbackUrl = (redirectUrl: string, query: PasskeyCallbackQuery): string =>
  appendQueryParams(redirectUrl, {
    provider: query.provider,
    action: query.action,
    status: query.status,
    ceremonyId: query.ceremonyId,
    authCode: query.authCode,
    reason: query.reason,
    state: query.state,
  });

export const buildPasskeyEntryFailureRedirectUrl = (
  redirectUrl: string,
  action: PasskeyAction,
  reason: PasskeyCallbackReason,
  state?: string,
): string =>
  buildPasskeyCallbackUrl(redirectUrl, {
    provider: 'PASSKEY',
    action,
    status: resolvePasskeyCallbackStatus(reason),
    reason,
    state,
  });

export const buildPasskeyCredentialSuccessCallbackUrl = (
  redirectUrl: string,
  query: PasskeyCallbackQuery,
  credentialJson: string,
): string => {
  const baseUrl = buildPasskeyCallbackUrl(redirectUrl, query);
  const hash = new URLSearchParams({ credentialJson }).toString();

  return `${baseUrl}#${hash}`;
};
